<template>
  <form @submit.prevent="agregarCuentaApartado">
    <div class="modal-card dialogo-cuenta">
      <header class="modal-card-head" :class="headClass">
        <div class="head-content">
          <b-icon :icon="tipo === 'cuenta' ? 'wallet-plus' : 'wallet-travel'" size="is-small" />
          <p class="modal-card-title">{{ titulo }}</p>
        </div>
        <button type="button" class="delete" @click="$emit('close', tipo)" />
      </header>

      <section class="modal-card-body">
        <!-- Cliente -->
        <busqueda-cliente
          @seleccionado="onSeleccionado"
          :initialCliente="cliente.nombre ? cliente : null"
        />

        <!-- Vence en -->
        <b-field class="mt-3" label="Vence en">
          <b-select class="wide" icon="calendar-clock" v-model="dias" required>
            <option value="" disabled>Seleccionar...</option>
            <option v-for="dia in DIAS" :key="dia" :value="dia">{{ dia }} días</option>
          </b-select>
        </b-field>

        <!-- Método de pago (solo si no hay id) -->
        <b-field v-if="!id" class="mt-3" label="Método de pago (anticipo)">
          <b-select class="wide" placeholder="Seleccionar..." icon="credit-card-outline" v-model="idMetodo" required>
            <option v-for="metodo in metodosSimples" :key="metodo" :value="metodo">{{ metodo }}</option>
            <option v-for="metodo in metodos" :key="metodo.id" :value="metodo.id">{{ metodo.nombre }}</option>
          </b-select>
        </b-field>

        <!-- Referencia (solo si método no es simple) -->
        <b-field label="Referencia / Origen" v-if="!esSimple && idMetodo">
          <b-input
            type="text"
            v-model="origen"
            placeholder="Nro. de referencia o descripción"
            icon="pound"
            required
          />
        </b-field>

        <!-- Moneda -->
        <!-- BUG FIX: moneda no estaba inicializada en data() original -->
        <b-field class="mt-3" label="Factura en">
          <b-select class="wide" icon="currency-usd" v-model="moneda" required @input="manejarMoneda">
            <option value="usd">Dólares ($)</option>
            <option value="bs">Bolívares (Bs.)</option>
          </b-select>
        </b-field>

        <!-- Delivery -->
        <div class="delivery-toggle mt-3">
          <b-switch v-model="esDelivery" @input="manejarEsDelivery" type="is-info">
            Incluir servicio de delivery
          </b-switch>
        </div>

        <div v-if="esDelivery" class="delivery-section">
          <p class="seccion-titulo">
            <b-icon icon="truck-delivery" size="is-small" />
            Datos del delivery
          </p>

          <b-field label="Costo del delivery">
            <b-input
              step="0.01"
              icon="currency-usd"
              type="number"
              placeholder="0.00"
              v-model="delivery.costo"
              @input="manejarCostoDelivery"
              required
            />
          </b-field>

          <b-switch class="mb-3" v-model="delivery.gratis" type="is-success"
            @input="$emit('actualizar', 'deliveryGratis', delivery.gratis)">
            Gratis para el cliente
          </b-switch>

          <b-field label="Destino">
            <b-input
              placeholder="Calle, casa, barrio, ciudad"
              v-model="delivery.destino"
              icon="map-marker"
              required
            />
          </b-field>

          <b-field label="Chofer(es)">
            <b-autocomplete
              v-model="busquedaChofer"
              :data="choferesFiltrados"
              field="nombre"
              placeholder="Buscar chofer..."
              open-on-focus
              @select="agregarChofer"
              :keep-first="true"
              icon="account-search"
              clearable
            >
              <template #empty>No se encontraron choferes</template>
            </b-autocomplete>
          </b-field>
          <div class="tags mt-1">
            <span v-for="(chofer, index) in choferesSeleccionados" :key="chofer.id" class="tag is-info is-medium">
              {{ chofer.nombre }}
              <button class="delete is-small" type="button" @click="eliminarChofer(index)" />
            </span>
          </div>
        </div>

        <!-- Pago inicial (solo si no hay id) -->
        <b-field v-if="!id" class="mt-3" label="Anticipo / Abono inicial">
          <b-input
            step="any"
            icon="currency-usd"
            type="number"
            placeholder="0.00 (dejar vacío si no hay anticipo)"
            v-model="pagado"
          />
        </b-field>

        <!-- Resumen -->
        <div class="pago-resumen">
          <div class="pago-fila">
            <span>Total</span>
            <span class="pago-monto">${{ formatoMonto(totalVenta) }}</span>
          </div>
          <div class="pago-fila" v-if="pagado">
            <span>Anticipo</span>
            <span class="pago-monto">${{ formatoMonto(pagado) }}</span>
          </div>
          <div class="pago-fila saldo-fila">
            <span>Por pagar</span>
            <span class="pago-monto saldo-valor">${{ formatoMonto(porPagar) }}</span>
          </div>
        </div>
      </section>

      <footer class="modal-card-foot dialogo-foot">
        <b-button label="Cancelar" icon-left="cancel" size="is-small" @click="$emit('close', tipo)" />
        <b-button
          :label="tipo === 'cuenta' ? 'Agregar a cuenta' : 'Registrar apartado'"
          :type="tipo === 'cuenta' ? 'is-info' : 'is-dark'"
          :icon-left="tipo === 'cuenta' ? 'wallet-plus' : 'wallet-travel'"
          size="is-small"
          native-type="submit"
        />
      </footer>
    </div>
  </form>
</template>

<script>
import BusquedaCliente from '../Clientes/BusquedaCliente'
import { DIAS, TIPOS_CLIENTE, TIPOS_PAGO_SIMPLE } from '@/consts'
import Utiles from '../../Servicios/Utiles'

export default {
  name: 'DialogoAgregarCuenta',
  components: { BusquedaCliente },

  props: {
    id: { type: Boolean, default: false },
    tipo: { type: String, default: null },
    totalVenta: { type: [String, Number], default: 0 },
    metodos: { type: Array, default: () => [] },
    choferes: { type: Array, default: () => [] },
    initialPagado: { type: Number, default: 0 },
    initialIdMetodo: { type: [String, Number], default: null },
    initialOrigen: { type: String, default: '' },
    initialCliente: { type: Object, default: () => ({}) },
    initialDias: { type: Number, default: 0 },
    initialDelivery: {
      type: Object,
      default: () => ({ costo: null, destino: null, gratis: false, idChofer: null })
    },
    initialChofer: {
      type: Object,
      default: () => ({ nombre: null, ci: null, tipo: null, telefono: null })
    },
    initialChoferesSeleccionados: { type: Array, default: () => [] }
  },

  data () {
    return {
      // BUG FIX: moneda, idMetodo y origen no estaban definidos en data() aunque se usaban
      // en el template. Se inicializan correctamente desde props o con valores por defecto.
      moneda: 'usd',
      pagado: this.initialPagado,
      idMetodo: this.initialIdMetodo ?? null,
      origen: this.initialOrigen ?? '',
      cliente: { ...this.initialCliente },
      esDelivery: !!(this.initialDelivery && (
        (Array.isArray(this.initialDelivery.idChofer) && this.initialDelivery.idChofer.length > 0) ||
        (typeof this.initialDelivery.idChofer === 'string' && this.initialDelivery.idChofer !== '') ||
        (typeof this.initialDelivery.idChofer === 'number' && this.initialDelivery.idChofer)
      )),
      nuevoChofer: false,
      delivery: {
        ...this.initialDelivery,
        idChofer: Array.isArray(this.initialDelivery?.idChofer)
          ? this.initialDelivery.idChofer
          : (this.initialDelivery?.idChofer !== null && this.initialDelivery?.idChofer !== undefined
            ? [this.initialDelivery.idChofer]
            : []),
        gratis: Boolean(this.initialDelivery?.gratis)
      },
      chofer: { ...this.initialChofer },
      dias: this.initialDias || 0,
      titulo: '',
      DIAS: DIAS,
      metodosSimples: Object.values(TIPOS_PAGO_SIMPLE),
      tipos: TIPOS_CLIENTE,
      busquedaChofer: '',
      choferesSeleccionados: [...this.initialChoferesSeleccionados]
    }
  },

  mounted () {
    this.titulo = this.tipo === 'cuenta' ? 'Agregar a cuenta' : 'Realizar apartado'
  },

  computed: {
    headClass () {
      return this.tipo === 'cuenta'
        ? 'head-info'
        : 'head-dark'
    },
    porPagar () {
      const secureTotalVenta = isNaN(this.totalVenta) ? 0 : parseFloat(this.totalVenta)
      const securePagado = isNaN(this.pagado) ? 0 : parseFloat(this.pagado)
      return Math.max(0, secureTotalVenta - securePagado)
    },
    esSimple () {
      return this.metodosSimples.includes(this.idMetodo)
    },
    choferesFiltrados () {
      return this.choferes.filter(c =>
        !this.choferesSeleccionados.some(sc => sc.id === c.id) &&
        c.nombre.toLowerCase().includes(this.busquedaChofer.toLowerCase())
      )
    }
  },

  methods: {
    formatoMonto (valor) {
      return Utiles.formatoMonto(valor)
    },
    onSeleccionado (cliente) {
      this.cliente = cliente
      this.delivery.destino = cliente.direccion
    },
    manejarEsDelivery () {
      this.$emit('actualizar', 'esDelivery', this.esDelivery)
    },
    manejarCostoDelivery () {
      this.$emit('actualizar', 'costoDelivery', this.delivery.costo)
    },
    manejarMoneda () {
      this.$emit('actualizar', 'moneda', this.moneda)
    },
    agregarCuentaApartado () {
      if (Object.keys(this.cliente).length === 0) {
        this.$buefy.toast.open({ type: 'is-danger', message: 'Debes seleccionar un cliente.' })
        return
      }
      if (!this.dias) {
        this.$buefy.toast.open({ type: 'is-danger', message: 'Debes seleccionar los días de vencimiento.' })
        return
      }

      let payload = {
        tipo: this.tipo,
        pagado: this.pagado,
        porPagar: this.porPagar,
        cliente: this.cliente,
        dias: this.dias,
        moneda: this.moneda
      }

      if (this.esDelivery) {
        if (this.choferesSeleccionados.length === 0) {
          this.$buefy.toast.open({ type: 'is-danger', message: 'Debes seleccionar al menos un chofer.' })
          return
        }
        payload.delivery = { ...this.delivery, idChofer: this.choferesSeleccionados.map(c => c.id) }
        payload.chofer = this.chofer
      }

      if (this.esSimple) {
        payload.simple = this.idMetodo
      } else {
        payload.idMetodo = this.idMetodo
        payload.origen = this.origen
      }

      this.$emit('terminar', payload)
    },
    agregarChofer (chofer) {
      if (chofer && !this.choferesSeleccionados.some(c => c.id === chofer.id)) {
        this.choferesSeleccionados.push(chofer)
        this.busquedaChofer = ''
      }
    },
    eliminarChofer (index) {
      this.choferesSeleccionados.splice(index, 1)
    }
  }
}
</script>

<style scoped>
.dialogo-cuenta { width: 520px; max-width: 95vw; }
.head-content { display: flex; align-items: center; gap: 0.5rem; }
.head-info { border-bottom: 2px solid var(--color-info) !important; }
.head-dark { border-bottom: 2px solid var(--color-text-muted) !important; }
.seccion-titulo {
  display: flex; align-items: center; gap: 0.4rem;
  font-size: 0.78rem; font-weight: 700; text-transform: uppercase;
  letter-spacing: .05em; color: var(--color-text-muted);
  margin: 0 0 0.75rem;
}
.delivery-toggle { margin-bottom: 0.25rem; }
.delivery-section {
  background: var(--color-surface2);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  padding: 0.85rem 1rem;
  margin-top: 0.5rem;
}
.pago-resumen {
  background: var(--color-surface2);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  padding: 0.75rem 1rem;
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}
.pago-fila {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  font-size: 0.84rem;
  color: var(--color-text-muted);
}
.pago-monto {
  font-family: var(--font-mono);
  font-weight: 600;
  color: var(--color-text);
}
.saldo-fila { border-top: 1px solid var(--color-border); padding-top: 0.35rem; margin-top: 0.1rem; }
.saldo-valor { color: var(--color-warning) !important; font-size: 1rem; }
.dialogo-foot { justify-content: flex-end; gap: 0.5rem; }
</style>
